const LOGGED_OUT_HOLDOUTS = {
  HOLDOUT_GROWTH_LOGGED_OUT_2026: "holdout_growth_logged_out_2026",
} as const satisfies Record<string, string>;

const TEACHER_HOLDOUTS = {
  HOLDOUT_VIEIRA_TEACHER_FIRST_HOLDOUT: "holdout_vieira_teacher_first_holdout",
} as const satisfies Record<string, string>;

export const ExternalSwitches = {
  WEB_SPARKS_HANDOFF_QR_CODE_IMPROVEMENT: "web_external_sparksHandoffQrCodeImprovement",
  WEB_EXTERNAL_PAYWALL_SPARKS: "web_external_paywall_sparks",
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey_v2",
  WEB_JOURNEY_SPARKS_TEST_MODAL: "web_journey_sparks_test_mode",
  WEB_EXTERNAL_TEACH_SSO_SIGNUP_OPTION_V5: "web_external_teach_sso_signup_option_v5",
  WEB_EXTERNAL_DISTRICTS_HUB_HERO: "web_external_districts_hub_hero",
  WEB_EXTERNAL_PARENT_LOGIN_MODAL_REDESIGN_V2: "web_external_parent_login_modal_redesign_v2",
  WEB_EXTERNAL_PARENT_SIGNUP_MODAL_REDESIGN_V3: "web_external_parent_signup_modal_redesign_v3",
  WEB_EXTERNAL_DOJO_ISLANDS_SIGNUP_LOGIN_BUTTONS: "web_external_dojo_islands_signup_login_buttons",
  WEB_EXTERNAL_HOMEPAGE_EXPERIMENT_HERO: "web_external_homepage_experiment_hero",
  WEB_EXTERNAL_SL_BTS_HERO: "web_external_sl_bts_hero",
  WEB_MARKETPLACE_LP_SIMPLIFIED_FUNNEL: "web_marketplace_lp_simplified_funnel",
  WEB_MARKETPLACE_HOMEPAGE_REDESIGN: "web_marketplace_homepage_redesign_sep2026_2",
  ...LOGGED_OUT_HOLDOUTS,
} as const;

export const LiteSwitches = {
  WEB_LITE_REDIRECT_EMAIL_VERIFICATION: "web_lite_redirect_email_verification_v3",
} as const;
export const TeacherSwitches = {
  WEB_TEACHER_VIEIRA_CLIENT_1: "web_teacher_vieira_client_1",
  WEB_TEACHER_VIEIRA_CLIENT_2: "web_teacher_vieira_client2",
  ...TEACHER_HOLDOUTS,
} as const;

export const featureSwitches = Object.values({ ...ExternalSwitches, ...TeacherSwitches, ...LiteSwitches });
export type FeatureSwitch = Exclude<
  (typeof featureSwitches)[number],
  | (typeof LOGGED_OUT_HOLDOUTS)[keyof typeof LOGGED_OUT_HOLDOUTS]
  | (typeof TEACHER_HOLDOUTS)[keyof typeof TEACHER_HOLDOUTS]
>;
export const defaultFSValues = featureSwitches.reduce((acc, fs) => ({ ...acc, [fs]: "off" }), {});
